export default __webpack_public_path__ + "macos675d5e.png";